"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentNavigation = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.content-navigation {\n  position: relative;\n  height: 39px;\n  border-bottom: 1px solid #d4d4d4; }\n  .content-navigation ul {\n    background: white; }\n  .content-navigation li button {\n    height: 40px; }\n  .content-navigation > .bx--tabs--scrollable {\n    display: flex;\n    justify-content: center;\n    position: absolute; }\n  .content-navigation .bx--tabs--scrollable .bx--tabs--scrollable__nav-link {\n    width: auto;\n    color: #a8a8a8;\n    font-size: 14px;\n    border-bottom-color: #d4d4d4;\n    outline: none;\n    margin: 0 0.5px; }\n  .content-navigation .bx--tabs--scrollable\n.bx--tabs--scrollable__nav-item--selected\n.bx--tabs--scrollable__nav-link,\n  .content-navigation .bx--tabs--scrollable\n.bx--tabs--scrollable__nav-item--selected\n.bx--tabs--scrollable__nav-link:focus,\n  .content-navigation .bx--tabs--scrollable\n.bx--tabs--scrollable__nav-item--selected\n.bx--tabs--scrollable__nav-link:active {\n    border-bottom-color: #e41b13;\n    color: #4c4c4c;\n    line-height: normal; }\n  .content-navigation .bx--tab-content {\n    display: none; }\n";
  const fileName = "ContentNavigation_ContentNavigation";
  const element = document.querySelector("style[data-sass-component='ContentNavigation_ContentNavigation']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ContentNavigation = props => {
  const tabItems = props.items.map(item => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Tab, {
      onClick: item.onClick,
      label: item.label,
      key: item.label,
      id: item.label
    }, item.content);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'content-navigation'
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Tabs, {
    selected: props.preselectedItemIndex
  }, tabItems));
};
exports.ContentNavigation = ContentNavigation;
ContentNavigation.propTypes = {
  items: _propTypes.default.array,
  preselectedItemIndex: _propTypes.default.number
};